<div class="modal-header">
  <div style="width: 100%">
    <div style="display: flex;align-items: flex-start;justify-content: space-between;">
      <h4 class="modal-title" id="modal-basic-title" style="width: 310px;flex: auto;">{{
        'bikeshop.modal.shedule_service.schedule_service' | translate}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <!-- <span aria-hidden="true">&times;</span> -->
        <span class="hubtiger-close"></span>
      </button>
    </div>

    <div class="wizard">
      <ul>
        <li>
          <a class="first">
            <span class="wizard-step" [ngClass]="{'active': step===1, 'complete' : step > 1}">
              <span [ngClass]="{'inner-circle':step === 1}"></span>
              <span [ngClass]="{'hide':step > 1}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===1, 'complete' : step > 1}">{{
              'bikeshop.modal.shedule_service.customer_details' | translate}}</span>
          </a>
        </li>
        <li>
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===2, 'complete' : step > 2}">
              <span [ngClass]="{'inner-circle':step === 2}"></span>
              <span [ngClass]="{'hide':step > 2}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===2, 'complete' : step > 2}">{{
              'bikeshop.modal.shedule_service.select_service' | translate}}</span>
          </a>
        </li>
        <li *ngIf="hasCustomQuestions">
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===3, 'complete' : step > 3}">
              <span [ngClass]="{'inner-circle':step === 3}"></span>
              <span [ngClass]="{'hide':step > 3}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===3, 'complete' : step > 3}">{{
              'bikeshop.shop_setup.card_headers.custom_questions' | translate}}</span>
          </a>
        </li>
        <li *ngIf="collectionsConfigured">
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===4, 'complete' : step > 4}">
              <span [ngClass]="{'inner-circle':step === 4}"></span>
              <span [ngClass]="{'hide':step > 4}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===4, 'complete' : step > 4}">{{
              'bikeshop.modal.shedule_service.collections' | translate}}</span>
          </a>
        </li>
        <li class="last">
          <a>
            <span class="wizard-step" [ngClass]="{'active': step===5}">
              <span [ngClass]="{'inner-circle':step === 5}"></span>
              <span [ngClass]="{'hide':step > 5}"></span>
            </span>
            <span class="wizard-title" [ngClass]="{'active': step===5, 'complete' : step > 4}">{{
              'bikeshop.modal.shedule_service.additional_notes' | translate}}</span>
          </a>
        </li>
      </ul>
    </div>

  </div>
</div>

<div class="modal-body">

  <div *ngIf="step===1">
    <!-- <div class="row margin-top-8" *ngIf="selectedDate">
      <div class="col-md-2 label"></div>
      <div class="col-md-8">
        <div class="p-inputgroup">
          <input type="text" pInputText [(ngModel)]="search"
            placeholder="{{ 'bikeshop.modal.shedule_service.search_customer' | translate}}"
            (keyup.enter)="searchCyclist()" />
          <span class="p-inputgroup-addon"><i class="fa hubtiger-search" (click)="searchCyclist()"></i></span>
        </div>
      </div>
    </div> -->

    <div style="margin-top:8px;">
      <div>
        <div joyrideStep="sheduleStepOne" text="{{ 'bikeshop.tour.schedule_job.step_one' | translate }}"
             (done)="tourCyclistDone()">
          <app-add-cyclist-bike [partnerId]="partnerId" (update)="bikeSelected($event)"
                                [user]="selectedCyclist"
                                [messageService]="messageService"
                                [selectedBike]="selectedBike"></app-add-cyclist-bike>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="step===2">
    <div class="row">
      <div class="col-md-2 label">{{ 'general.jobcard_no' | translate}}:</div>
      <div class="col-md-9 value">
        {{jobCardNo}}
      </div>
    </div>
    <div joyrideStep="sheduleStepTwo" class="margin-top-8"
         text="{{ 'bikeshop.tour.schedule_job.step_two' | translate }}" (done)="tourServiceTypesDone()">
      <div class="row">
        <div class="col-md-2 label" [ngClass]="{'red': selectedServiceTypes.length === 0}">
          {{ 'bikeshop.modal.shedule_service.service_types' | translate}}:
        </div>
        <div class="col-md-9">
          <p-multiSelect #serviceTypeDropDown [options]="serviceTypes" [(ngModel)]="selectedServiceTypes"
                         [optionValue]="'value'" [optionLabel]="'label'" (onChange)="getAvailableSlots()"
                         [filter]="true" filterBy="search,reverseSearch" scrollHeight="450px"
                         [resetFilterOnHide]="true"
                         autofocus="true" [showToggleAll]="false"
                         defaultLabel="{{ 'general.choose' | translate}}">
          </p-multiSelect>
        </div>
      </div>
    </div>

    <div *ngIf="showThirdParties == true">
      <div class="row margin-top-8">
        <div class="col-md-2 label">
          {{ "bikeshop.modal.shedule_service.thirdparty" | translate }}:
        </div>
        <div class="col-md-9">
          <p-dropdown [options]="thirdParties" [(ngModel)]="selectedThirdParty"
                      placeholder="{{ 'general.choose' | translate }}"></p-dropdown>
        </div>
      </div>

      <div class="row margin-top-8" *ngIf="selectedThirdParty != null">
        <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.thirdparty_responsibleforpayment' | translate}}
          :
        </div>
        <div class="col-md-9">
          <p-inputSwitch [(ngModel)]="selectedThirdPartyIsResponsibileForPayment"
                         [disabled]="selectedThirdParty == null"></p-inputSwitch>
        </div>
      </div>
    </div>


    <!-- <div class="row margin-top-8" *ngIf="!fromCalendar && availableDates && availableDates.length>0">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.available_dates' | translate}}:</div>
      <div class="col-md-9">
        <p-dropdown [options]="availableDates" [(ngModel)]="selectedDate"></p-dropdown>
      </div>
    </div> -->
    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.service_date' | translate}}:</div>
      <!-- <div class="col-md-9 value">{{selectedDate | date : "yyyy-MM-dd HH:mm" }}</div> -->
      <div class="col-md-4 value" *ngIf="bookedDate">
        <p-calendar [(ngModel)]="bookedDate" dateFormat="{{countryData.DatePickerFormat}}" [stepMinute]="15"
                    [readonlyInput]="true" [showTime]="true" (onSelect)="changeServiceDate()"></p-calendar>
      </div>      
      <div class="col-md-2 label" *ngIf="!fromCalendar && technician">{{ 'bikeshop.print.technician' | translate}}:</div>
      <!-- <div class="col-md-9 value">{{selectedDate | date : "yyyy-MM-dd HH:mm" }}</div> -->
      <div class="col-md-3 value" *ngIf="!fromCalendar && technician">
        <p-dropdown [options]="technicians" [(ngModel)]="technician" optionLabel="name" optionValue="id" (onChange)="getAvailableSlots(true)">
        </p-dropdown>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.is_bike_here' | translate}}:</div>
      <div class="col-md-9">
        <p-inputSwitch [(ngModel)]="isBikeHere" [disabled]="isWalkIn || rentalBike"></p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="isBikeHere">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shared.bike.bay_tag_number' | translate}}:</div>
      <div class="col-md-4 value">
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="bikeBay"/>
        </div>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="fromCalendar || selectedDate">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shedule_service.required_by' | translate}}:</div>
      <div class="col-md-4 value">
        <p-calendar dateFormat="{{countryData.DatePickerFormat}}"
                    placeholder="{{ 'bikeshop.modal.shedule_service.required_by' | translate}}"
                    [minDate]="bookedDate"
                    [readonlyInput]="true" [(ngModel)]="requiredBy" [stepMinute]="5" [showTime]="true"
                    [defaultDate]="defaultRequiredByDate" [selectOtherMonths]="true"></p-calendar>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label">{{ "bikeshop.modal.update_job_card.job_card.coupon_code" | translate }}:</div>
      <div class="col-md-4 value">
        <div class="p-inputgroup">
          <input pInputText type="text" [(ngModel)]="couponCode"
                 (ngModelChange)="couponCode = $event.toUpperCase(); couponCodeValid = false; couponError = '';"
                 (keydown)="inputChanged()" (focus)="editingCouponCode = true"
                 (blur)="editingCouponCode = false"/>
          <span class="p-inputgroup-addon"
                [ngClass]="{'green': couponCodeValid, 'red': !couponCodeValid && couponCode && couponCode.length > 0}"
                (click)="checkCouponCode()">
            <i class="fa"
               [ngClass]="{'fa-check': !couponCode || couponCode.length === 0 || couponCodeValid, 'fa-times': !couponCodeValid && couponCode && couponCode.length > 0}"></i>
          </span>
        </div>
      </div>
      <div class="col-md-6 value">
        <span class="red bold" *ngIf="couponError">{{couponError}}</span>
        <span class="green bold"
              *ngIf="couponCodeValid">{{ 'bikeshop.coupons.coupon_code_valid' | translate }}</span>
      </div>
    </div>

    <div class="row margin-top-8">
      <div class="col-md-2 label" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
        {{
        'bikeshop.modal.update_job_card.job_card.send_communication' | translate
        }}:
      </div>
      <div class="col-md-9">
        <p-inputSwitch [(ngModel)]="sendCommunication" [disabled]="rentalBike"></p-inputSwitch>
      </div>
    </div>

    <div class="row margin-top-8" *ngIf="showGDPRMarketingConsent == true && userGaveGDPRMarketingConsent == false">
      <div class="col-md-2 label" style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
        {{
        'bikeshop.modal.update_job_card.job_card.showgdprconsent' | translate
        }}:
      </div>
      <div class="col-md-9" style="display:flex;align-items: center;">
        <p-inputSwitch [(ngModel)]="consentForMarketing"></p-inputSwitch>
        <small style="
            margin-left: 8px;
            margin-top: auto;
            margin-bottom: auto;
          ">
          {{
          "bikeshop.modal.update_job_card.job_card.showgdprconsent_info" | translate
          }}
        </small>
      </div>
    </div>

    <div class="row margin-top-8" *ngIf="partner.CreatedByOverrideOnBooking">
      <div class="col-md-2 label" [ngClass]="{'red': !createdBy}">
        {{ 'bikeshop.modal.shedule_service.booked_in_by' | translate}}:
      </div>
      <div class="col-md-4">
        <p-dropdown [options]="systemUsers" [(ngModel)]="createdBy">
        </p-dropdown>
      </div>
    </div>

    <!--<div class="row margin-top-8">
      <div class="col-md-2 label">{{ 'bikeshop.modal.shared.pre-approved-amount' | translate}}:</div>
      <div class="col-md-4 value">
        <div class="p-inputgroup">
          <input pInputText style="padding-right: 8px;" type="number" step="0.01" [(ngModel)]="preapprovedAmount" />
        </div>
      </div>
    </div>-->

  </div>

  <div *ngIf="step===3">

    <div class="no-servicetype-questions"
         *ngIf="!loadingCustomQuestions && (!serviceTypeQuestions || (serviceTypeQuestions && serviceTypeQuestions.length === 0))">
      {{'bikeshop.workshop.custom_questions.no_custom_questions' | translate}}
    </div>

    <p-accordion>
      <p-accordionTab
        header="{{serviceType.groupName + ' - ' + serviceType.serviceType}}"
        *ngFor="let serviceType of serviceTypeQuestions"
        [ngClass]="{'red': hasMandatoryQuestion(serviceType)}">
        <div *ngFor="let question of serviceType.customQuestions;let i = index;" class="row"
             [ngClass]="{'margin-top-8': i > 0}">
          <div class="col-md-3 label" [ngClass]="{'red': question.mandatory && !question.response}">
            {{question.question}}</div>
          <div class="col-md-9">
            <div class="p-inputgroup" *ngIf="question.controlType === 'TEXTINPUT'">
              <span class="p-inputgroup-addon"></span>
              <input type="text" pInputText [(ngModel)]="question.response" [placeholder]="question.hint">
            </div>
            <div class="p-inputgroup" *ngIf="question.controlType === 'TEXTAREA'">
              <textarea rows="5" pInputTextarea [(ngModel)]="question.response"
                        [placeholder]="question.hint"></textarea>
            </div>
            <div class="p-inputgroup" *ngIf="question.controlType === 'CHECKBOX'">
              <p-checkbox [(ngModel)]="question.response" [binary]="true" inputId="binary"></p-checkbox>
              <small style="margin-left: 8px;font-style: italic;">{{question.hint}}</small>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>

  <div *ngIf="step===4">

    <div class="row">
      <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.collection' | translate}}:</div>
      <div class="col-md-3">
        <p-inputSwitch [(ngModel)]="allowCollection" (ngModelChange)="allowDelivery = allowCollection">
        </p-inputSwitch>
      </div>
    </div>

    <div class="row margin-top-8" *ngIf="allowCollection">
      <div class="col-md-3 label" [ngClass]="{'red': allowCollection && !collection.fullAddress}">
        {{ 'bikeshop.modal.update_job_card.collections.collection_address' | translate }}:
      </div>
      <div class="col-md-9">
        <div class="p-inputgroup">
          <p-autoComplete [(ngModel)]="collection.fullAddress" [suggestions]="addressOptions"
                          (completeMethod)="searchAddress($event)"
                          (onSelect)="onSelectAddress($event,'COLLECTION')" field="address">
          </p-autoComplete>
          <div *ngIf="collectionAddrssLoading">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                               fill="transparent"
                               animationDuration=".5s">
            </p-progressSpinner>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="!collectionAddrssLoading && collection.addressOutOfRange">
      <div class="col-md-3"></div>
      <div class="col-md-9 label red">{{'bikeshop.modal.shedule_service.collections_address_out_of_range' | translate}}
      </div>
    </div>

    <div class="row margin-top-8" *ngIf="allowCollection">
      <div class="col-md-3 label" [ngClass]="{'red': !collection.scheduleDate}">{{
        'bikeshop.modal.update_job_card.collections.collection_date' | translate}}:
      </div>
      <div class="col-md-3 value">
        <p-calendar dateFormat="{{countryData.DatePickerFormat}}"
                    placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_date' | translate}}"
                    [minDate]="minDate" [maxDate]="maxDate" [(ngModel)]="collection.scheduleDate"
                    [disabledDates]="unavailableCollectionDates" (onSelect)="setBookingDate(true)"
                    [disabled]="!collection.areaID"
                    (onMonthChange)="monthChanged($event)" [showOtherMonths]="false"></p-calendar>
      </div>
      <div class="col-md-2 label"
           [ngClass]="{'red': allowCollection && (!collection.timeSlot || !collection.timeSlot.deliveryVehicleID)}">{{
        'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}:
      </div>
      <div class="col-md-4">
        <p-dropdown [options]="collectionTimeSlots" (onChange)="selectTimeSlot($event)"
                    [disabled]="collection.scheduleDate === null || collectionTimeSlots.length === 0"
                    [ngModel]="collection.timeSlot" optionLabel="label"
                    placeholder="{{ 'bikeshop.modal.update_job_card.collections.collection_time_slot' | translate}}"></p-dropdown>
      </div>
    </div>

    <div class="row margin-top-8"
         *ngIf="allowCollection && collection && collection.scheduleDate && scheduleDateLessThanCollection() && collection.updatedBookingDate">
      <div class="col-md-3"></div>
      <div class="col-md-9 label red">{{ 'bikeshop.modal.update_job_card.collections.schedule_date_change' | translate :
        {bookingDate: getFriendlyBookingDate()} }}</div>
    </div>

    <div class="row margin-top-8" *ngIf="allowCollection">
      <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.customer_notes' | translate }}:
      </div>
      <div class="col-md-9">
        <div class="p-inputgroup">
          <input type="text" pInputText [(ngModel)]="collection.notes"
                 placeholder="{{ 'bikeshop.modal.update_job_card.collections.customer_notes' | translate }}"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-3 label">{{ 'bikeshop.modal.update_job_card.collections.delivery' | translate}}:</div>
      <div class="col-md-3">
        <p-inputSwitch [(ngModel)]="allowDelivery">
        </p-inputSwitch>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="allowDelivery && !allowCollection">
      <div class="col-md-3 label">
        {{ 'bikeshop.modal.update_job_card.collections.delivery_address' | translate }}:
      </div>
      <div class="col-md-9">
        <div class="p-inputgroup">
          <p-autoComplete [(ngModel)]="delivery.fullAddress" [suggestions]="addressOptions"
                          (completeMethod)="searchAddress($event)"
                          (onSelect)="onSelectAddress($event,'DELIVERY')" field="address">
          </p-autoComplete>
          <div *ngIf="deliveryAddrssLoading">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
                               fill="transparent"
                               animationDuration=".5s">
            </p-progressSpinner>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="!allowCollection && !deliveryAddrssLoading && delivery.addressOutOfRange">
      <div class="col-md-3"></div>
      <div class="col-md-9 label red">{{'bikeshop.modal.shedule_service.collections_address_out_of_range' | translate}}
      </div>
    </div>

  </div>

  <div *ngIf="step===5">
    <div class="row margin-top-8">
      <div class="col-md-12">
        <div class="checklist-container-header">{{ 'bikeshop.modal.shedule_service.customer_notes' | translate}}
        </div>
        <textarea [rows]="5" [(ngModel)]="customerNotes" pInputTextarea [autoResize]="true"
                  class="p-fluid"></textarea>
      </div>
    </div>

    <div class="row margin-top-8" *ngIf="preServiceChecklist.length > 0">
      <div class="col-12">
        <div>
          <div class="checklist-container-header">{{ 'bikeshop.modal.update_job_card.checklist.pre_service_checklist' |
            translate
            }}
          </div>
          <div class="vertical-checklist">
            <div *ngFor="let checklistItem of preServiceChecklist">
              <div>
                <div class="checklist-label" [ngStyle]="{ 'color': checklistItem.labelColour }">
                  {{checklistItem.description}}
                </div>
                <div *ngIf="!checklistItem.frontRearCheck">
                  <div *ngIf="checklistItem.controlType === 'CHECKBOX'">
                    <p-checkbox [(ngModel)]="checklistItem.defaultValue"
                                [binary]="true"></p-checkbox>
                  </div>
                  <div *ngIf="checklistItem.controlType === 'TEXT'">
                    <input type="text" pInputText [(ngModel)]="checklistItem.defaultValue" />
                  </div>
                  <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'">
                    <textarea type="text" pInputText [(ngModel)]="checklistItem.defaultValue" rows="5"
                              (blur)="updateChecklistItem(checklistItem)"
                              style="width:100%; word-break:break-word;"></textarea>
                  </div>
                  <div *ngIf="checklistItem.controlType === 'RADIO'">
                    <div>
                      <p-radioButton name="{{checklistItem.description}}"
                                     value="{{'general.yes' | translate}}"
                                     label="{{('general.yes' | translate).substring(0,1)}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     labelStyleClass="p-radiobutton-label-override"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                      <p-radioButton name="{{checklistItem.description}}"
                                     value="{{'general.no' | translate}}"
                                     label="{{('general.no' | translate).substring(0,1)}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     labelStyleClass="p-radiobutton-label-override"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                      <p-radioButton name="{{checklistItem.description}}"
                                     value="{{'general.not_applicable' | translate}}"
                                     label="NA" [(ngModel)]="checklistItem.defaultValue"
                                     labelStyleClass="p-radiobutton-label-override"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                    </div>
                  </div>
                  <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'">
                    <div class="radio-group">
                      <p-radioButton name="{{checklistItem.description}}_F"
                                     value="{{'general.yes' | translate}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     styleClass="red-border"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                      <p-radioButton name="{{checklistItem.description}}_F"
                                     value="{{'general.no' | translate}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     styleClass="yellow-border"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                      <p-radioButton name="{{checklistItem.description}}_F"
                                     value="{{'general.not_applicable' | translate}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     styleClass="green-border"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>

                      <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500" style="max-width:163px;min-width:163px"
                             (blur)="updateChecklistItem(checklistItem)" />

                    </div>
                  </div>
                </div>
                <div *ngIf="checklistItem.frontRearCheck">
                  <div *ngIf="checklistItem.controlType === 'CHECKBOX'" class="front-rear-check">
                    <span>F</span>
                    <p-checkbox [(ngModel)]="checklistItem.frontValue" [binary]="true"></p-checkbox>
                    <span>R</span>
                    <p-checkbox [(ngModel)]="checklistItem.rearValue" [binary]="true"></p-checkbox>
                  </div>
                  <div *ngIf="checklistItem.controlType === 'TEXT'" class="front-rear-check">
                    <span>F</span>
                    <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" />
                    <span>R</span>
                    <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" />
                  </div>
                  <div *ngIf="checklistItem.controlType === 'MULTILINETEXT'" class="front-rear-check">
                    <span>F</span>
                    <textarea type="text" pInputText [(ngModel)]="checklistItem.frontValue" rows="5"
                              (blur)="updateChecklistItem(checklistItem)"
                              style="width:40% !important; word-break:break-word;"></textarea>
                    <span>R</span>
                    <textarea type="text" pInputText [(ngModel)]="checklistItem.rearValue" rows="5"
                              (blur)="updateChecklistItem(checklistItem)"
                              style="width:40% !important; word-break:break-word;"></textarea>
                  </div>
                  <div *ngIf="checklistItem.controlType === 'RADIO'" class="front-rear-check">
                    <span>F</span>
                    <p-radioButton name="{{checklistItem.description}}_F"
                                   value="{{'general.yes' | translate}}"
                                   label="{{('general.yes' | translate).substring(0,1)}}"
                                   [(ngModel)]="checklistItem.frontValue"
                                   labelStyleClass="p-radiobutton-label-override"
                                   (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                    <p-radioButton name="{{checklistItem.description}}_F"
                                   value="{{'general.no' | translate}}"
                                   label="{{('general.no' | translate).substring(0,1)}}"
                                   [(ngModel)]="checklistItem.frontValue"
                                   labelStyleClass="p-radiobutton-label-override"
                                   (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                    <p-radioButton name="{{checklistItem.description}}_F"
                                   value="{{'general.not_applicable' | translate}}"
                                   label="NA" [(ngModel)]="checklistItem.frontValue"
                                   labelStyleClass="p-radiobutton-label-override"
                                   (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                    <br />
                    <span>R</span>
                    <p-radioButton name="{{checklistItem.description}}_R"
                                   value="{{'general.yes' | translate}}"
                                   label="{{('general.yes' | translate).substring(0,1)}}"
                                   [(ngModel)]="checklistItem.rearValue"
                                   labelStyleClass="p-radiobutton-label-override"
                                   (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                    <p-radioButton name="{{checklistItem.description}}_R"
                                   value="{{'general.no' | translate}}"
                                   label="{{('general.no' | translate).substring(0,1)}}"
                                   [(ngModel)]="checklistItem.rearValue"
                                   labelStyleClass="p-radiobutton-label-override"
                                   (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                    <p-radioButton name="{{checklistItem.description}}_R"
                                   value="{{'general.not_applicable' | translate}}"
                                   label="NA" [(ngModel)]="checklistItem.rearValue"
                                   labelStyleClass="p-radiobutton-label-override"
                                   (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                  </div>
                  <div *ngIf="checklistItem.controlType === 'TRAFFICLIGHT'" class="front-rear-check">
                    <div class="radio-group">


                      <p-radioButton name="{{checklistItem.description}}_F"
                                     value="{{'general.yes' | translate}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     styleClass="red-border"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                      <p-radioButton name="{{checklistItem.description}}_F"
                                     value="{{'general.no' | translate}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     styleClass="yellow-border"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>
                      <p-radioButton name="{{checklistItem.description}}_F"
                                     value="{{'general.not_applicable' | translate}}"
                                     [(ngModel)]="checklistItem.defaultValue"
                                     styleClass="green-border"
                                     (onClick)="updateChecklistItem(checklistItem)"></p-radioButton>



                      <span style="padding-top:2%">F</span>
                      <input type="text" pInputText [(ngModel)]="checklistItem.frontValue" maxlength="1500"
                             (blur)="updateChecklistItem(checklistItem)" />

                      <span style="padding-top:2%">R</span>
                      <input type="text" pInputText [(ngModel)]="checklistItem.rearValue" maxlength="1500"
                             (blur)="updateChecklistItem(checklistItem)" />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</div>
<div class="modal-footer">

  <div class="row">

    <div class="col-md-3" *ngIf="step>1">
      <button *ngIf="step>1" pButton type="button" class="p-button-raised full-width" (click)="back()"
              label="{{ 'bikeshop.modal.shedule_service.button.back' | translate}}"></button>
    </div>
    <div class="col-md-3" *ngIf="step==1"></div>
    <div class="col-md-3" *ngIf="step==1"></div>
    <div class="col-md-3" *ngIf="step>1 && step!==5">
      <div *ngIf="step==2 && !rentalBike">
        <button pButton type="button" class="p-button-raised full-width accent"
                (click)="scheduleBookingAndOpen()"
                label="{{ 'bikeshop.modal.shedule_service.button.schedule_and_open' | translate}}"
                [disabled]="!selectedDate || selectedServiceTypes.length===0 || submitting || (partner.CreatedByOverrideOnBooking && !createdBy)"></button>
      </div>
    </div>
    <div class="col-md-3">
      <div *ngIf="step===2">
        <button pButton type="button" class="p-button-raised full-width icon" iconPos="right"
                (click)="scheduleBooking()"
                label="{{ 'bikeshop.modal.shedule_service.button.schedule' | translate}}"
                [disabled]="!selectedDate || selectedServiceTypes.length===0 || submitting || (partner.CreatedByOverrideOnBooking && !createdBy)"></button>
      </div>
      <div *ngIf="step===3">
        <button pButton type="button" class="p-button-raised full-width icon" iconPos="right"
                (click)="scheduleBooking()"
                label="{{ 'bikeshop.modal.shedule_service.button.schedule' | translate}}"
                [disabled]="!mandatoryCustomQuestionsCompleted() || submitting"></button>
      </div>
      <div *ngIf="step===4">
        <button pButton type="button" class="p-button-raised full-width icon" iconPos="right"
                (click)="scheduleBooking()"
                label="{{ 'bikeshop.modal.shedule_service.button.schedule' | translate}}"
                [disabled]="!validateCollection() || submitting"></button>
      </div>
    </div>
    <div class="col-md-3" *ngIf="step===1 && selectedBike && selectedBike.ID">
      <button pButton type="button" class="p-button-raised full-width" (click)="next()"
              label="{{ 'bikeshop.modal.shedule_service.button.next' | translate}}"
              [disabled]="selectedBike && !selectedBike.ID"></button>
    </div>
    <div class="col-md-3" *ngIf="step===2">
      <button pButton type="button" class="p-button-raised full-width" (click)="next()"
              label="{{ 'bikeshop.modal.shedule_service.button.next' | translate}}"
              [disabled]="!selectedDate || selectedServiceTypes.length===0 || submitting || (partner.CreatedByOverrideOnBooking && !createdBy)"></button>
    </div>
    <div class="col-md-3" *ngIf="step===3">
      <button pButton type="button" class="p-button-raised full-width" (click)="next()"
              label="{{ 'bikeshop.modal.shedule_service.button.next' | translate}}"
              [disabled]="!mandatoryCustomQuestionsCompleted() || submitting"></button>
    </div>
    <div class="col-md-3" *ngIf="step===4">
      <button pButton type="button" class="p-button-raised full-width" (click)="next()"
              label="{{ 'bikeshop.modal.shedule_service.button.next' | translate}}"
              [disabled]="!validateCollection() || submitting"></button>
    </div>
    <div class="col-md-3" *ngIf="step===5">
      <button pButton type="button" class="p-button-raised full-width accent" (click)="scheduleBookingAndOpen()"
              *ngIf="!rentalBike"
              label="{{ 'bikeshop.modal.shedule_service.button.schedule_and_open' | translate}}"
              [disabled]="submitting"></button>
    </div>
    <div class="col-md-3" *ngIf="step===5 && !submitting">
      <button pButton type="button" class="p-button-raised full-width icon"
              iconPos="right" (click)="scheduleBooking()"
              label="{{ 'bikeshop.modal.shedule_service.button.schedule' | translate}}"
              [disabled]="false"></button>
    </div>

    <div class="col-md-3" *ngIf="step===5 && submitting">
      <button pButton type="button" class="p-button-raised full-width icon" icon="pi pi-spin pi-spinner"
              iconPos="right" (click)="scheduleBooking()"
              label="{{ 'bikeshop.modal.shedule_service.button.schedule' | translate}}"
              [disabled]="true"></button>
    </div>
  </div>
  <!-- <hr/>
  <div class="row" *ngIf="step===1">

    <div class="col-md-3" *ngIf="step===1"><input type="text" [(ngModel)]="newWalkInName" pInputText placeholder="Name" /></div>
    <div class="col-md-3" *ngIf="step===1"><input type="text" [(ngModel)]="newWalkInPhone" pInputText placeholder="Phone number" /></div>
    <div class="col-md-3" *ngIf="step===1"><input type="email" [(ngModel)]="newWalkInEmail" pInputText placeholder="eMail" /></div>

    <div class="col-md-3">
      <div>
        <button pButton type="button" class="p-button-raised full-width icon"
                (click)="createWalkin()" label="{{ 'bikeshop.modal.shedule_service.button.create_quickbookin' | translate}}"
                [disabled]="!(walkInBusy || (newWalkInName.length > 0 && (newWalkInPhone.length > 0 || newWalkInEmail.length > 0)))"></button>
      </div>
    </div>
  </div> -->
  <!-- <div class="row" *ngIf="step===1 && newWalkInName.length > 0 && (newWalkInPhone.length === 0 || newWalkInEmail.length === 0)">
    <div class="col-md-12 label">{{ 'bikeshop.modal.shedule_service.enter_either_email_or_phone_or_both' | translate }}</div>
  </div> -->
</div>

<p-toast position="top-center" styleClass="hubtiger-toast"></p-toast>
